const formatDateToFiCulture = (date: Date): string => {
    let publicationDate = "";
    if (date) {
        publicationDate = date.toLocaleDateString("fi-FI");
        return publicationDate;
    } else {
        return "";
    }
};

export const commonStingManagerManager = {
    formatDateToFiCulture
};


// WEBPACK FOOTER //
// ./src/api/commonStingManagerManager.ts